import { SVGProps } from 'react'

const HandBaggageOnlyIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M4.00033 13.3333C3.6467 13.3333 3.30756 13.1929 3.05752 12.9428C2.80747 12.6928 2.66699 12.3536 2.66699 12V5.33333C2.66699 4.97971 2.80747 4.64057 3.05752 4.39052C3.30756 4.14048 3.6467 4 4.00033 4H12.0003C12.3539 4 12.6931 4.14048 12.9431 4.39052C13.1932 4.64057 13.3337 4.97971 13.3337 5.33333V12C13.3337 12.3536 13.1932 12.6928 12.9431 12.9428C12.6931 13.1929 12.3539 13.3333 12.0003 13.3333"
            stroke="#999999"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.33301 12V2.66671C5.33301 2.31309 5.47348 1.97395 5.72353 1.7239C5.97358 1.47385 6.31272 1.33337 6.66634 1.33337H9.33301C9.68663 1.33337 10.0258 1.47385 10.2758 1.7239C10.5259 1.97395 10.6663 2.31309 10.6663 2.66671V12"
            stroke="#999999"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.66699 13.3334H9.33366" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10.6663 14.6667C11.4027 14.6667 11.9997 14.0697 11.9997 13.3333C11.9997 12.597 11.4027 12 10.6663 12C9.92996 12 9.33301 12.597 9.33301 13.3333C9.33301 14.0697 9.92996 14.6667 10.6663 14.6667Z"
            stroke="#999999"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z"
            stroke="#999999"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <g clipPath="url(#clip0_39_686)">
            <path
                d="M16.0003 14.3333C17.8413 14.3333 19.3337 12.8409 19.3337 11C19.3337 9.15901 17.8413 7.66663 16.0003 7.66663C14.1594 7.66663 12.667 9.15901 12.667 11C12.667 12.8409 14.1594 14.3333 16.0003 14.3333Z"
                stroke="#D50707"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M13.6338 8.6333L18.3671 13.3666" stroke="#D50707" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_39_686">
                <rect width="8" height="8" fill="white" transform="translate(12 7)" />
            </clipPath>
        </defs>
    </svg>
)

export default HandBaggageOnlyIcon
